import { Helmet } from 'react-helmet-async';
import { Layout } from '@/components/layout/Layout';
import { useContactData } from '@/hooks/useContactData';
import { useNavigationData } from '@/hooks/useNavigationData';
import { useSiteData } from '@/hooks/useSiteData';

export function CivilianMarksmanshipProgram() {
  const { siteData } = useSiteData();
  const { contactInfo } = useContactData();
  const { navigationItems } = useNavigationData();

  return (
    <>
      <Helmet>
        <title>Civilian Marksmanship Program - {siteData.title}</title>
        <meta
          name="description"
          content="Civilian Marksmanship Program at Wayland Rod and Gun Club. View our CMP certification and learn about marksmanship training programs."
        />
        <meta name="keywords" content="CMP, Civilian Marksmanship Program, marksmanship, training, shooting, certification" />
      </Helmet>

      <Layout contactInfo={contactInfo} navigationItems={navigationItems}>
        <div className="p-4 sm:p-8 space-y-8 sm:space-y-12 max-w-4xl mx-auto">
          <div className="text-center">
            <h1 className="text-4xl sm:text-5xl font-cursive text-primary-700 mb-8">
              Civilian Marksmanship Program
            </h1>
          </div>

          <div className="flex justify-center">
            <div className="border-4 border-neutral-400 p-4 inline-block">
              <img
                src="/images/cmp-certificate.png"
                alt="CMP Certificate - Civilian Marksmanship Program certification from Wayland Rod and Gun Club"
                className="max-w-full h-auto"
              />
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}